import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-081899f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "INR" }, "INR", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "submit",
  value: "pay"
}, null, -1))
const _hoisted_7 = {
  method: "post",
  name: "paytm-form",
  target: "_blank"
}
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.getTransactionToken && _ctx.getTransactionToken(...args)), ["prevent"]))
    }, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.transaction.currency) = $event))
      }, _hoisted_3, 512), [
        [_vModelSelect, _ctx.transaction.currency]
      ]),
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        type: "number",
        min: "0",
        placeholder: "amount",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.transaction.amount) = $event))
      }, null, 512), [
        [_vModelText, _ctx.transaction.amount]
      ]),
      _hoisted_5,
      _hoisted_6
    ], 32),
    _createElementVNode("form", _hoisted_7, [
      _createElementVNode("input", {
        type: "hidden",
        name: "mid",
        value: _ctx.paytm.mid
      }, null, 8, _hoisted_8),
      _createElementVNode("input", {
        type: "hidden",
        name: "orderId",
        value: _ctx.paytm.orderId
      }, null, 8, _hoisted_9),
      _createElementVNode("input", {
        type: "hidden",
        name: "txnToken",
        value: _ctx.paytm.txnToken
      }, null, 8, _hoisted_10)
    ])
  ]))
}